exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/modules/_wks-ext.js
// module id = 78
// module chunks = 0